import sliderStyle from "../templates/Slider.style";
import sliderHzeroStyle from "../templates-hzero/Slider.style";
var sliderData = {
  name: 'slider',
  data: [{
    showTip: true
  }],
  onlyTemplate: {
    base: sliderStyle,
    hzero: sliderHzeroStyle
  }
};
export default sliderData;